import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2TemplateService } from './fi-checklist2-template.service';
import { FiChecklist2TemplateListComponent } from './fi-checklist2-template-list/fi-checklist2-template-list.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCardModule } from '@angular/material/card';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiChecklist2ListModule } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiChecklistAddChecklistTemplateDialogComponent } from '@fi-shared/checklist/fi-checklist2-template/add-checklist-template-dialog/add-checklist-template-dialog.component';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { FiChecklist2GeneralSectionEditModule } from '@fi-shared/checklist/fi-checklist2-edit/general-section-edit/general-section-edit.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiChecklist2SharedModule } from '../fi-checklist2-shared/fi-checklist2-shared.module';
import { FiNameDescriptionInputModule } from '@fi-shared/name-description-input/name-description-input.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatCardModule,
        MatSortModule,
        MatTableModule,
        FiWhenScrolledModule,
        FiChecklist2ListModule,
        FiFormatDateModule,
        FiItemsListModule,
        MatButtonModule,
        MatIconModule,
        FiChecklist2ListColumnDefsModule,
        FiChecklist2SharedModule,
        MatRadioGroup,
        MatRadioButton,
        FormsModule,
        FiChecklist2GeneralSectionEditModule,
        SelectSearchModule,
        FiNameDescriptionInputModule,
    ],
    declarations: [FiChecklist2TemplateListComponent, FiChecklistAddChecklistTemplateDialogComponent],
    providers: [FiChecklist2TemplateService],
})
export class FiChecklist2TemplateModule {}
